// packages/apps/pro-studio/src/stores/utils/type-to-edit-focus.ts
//
// PSTUDIO-4846: a type-to-edit entry REPLACES the stored text with what is
// typed, but the first character is injected one frame after the control
// mounts. A key typed natively into the control before that frame has to
// replace the stored text as well, or it lands behind it and the frame's
// assignment discards it. Selecting the stored text when the control is focused
// gives the native key exactly that replace semantics.
//
// Lives here, not inline in cell.tsx, because cell.tsx cannot be imported by a
// unit test (it pulls in the design system). The call in cell.tsx is the one
// line this file does not cover.

/** The seed `tableStore.typedSeedInFlight` holds while its frame is pending. */
export interface TypedSeedInFlight {
  cellKey: string;
}

/**
 * Select the control's whole text when `seed` belongs to the cell being
 * focused. Returns whether it selected. Any other entry (double click, F2,
 * Enter) has no seed for this cell and keeps the caret where it was put.
 */
export function selectStoredTextForTypeToEdit(
  input: HTMLInputElement | HTMLTextAreaElement,
  seed: TypedSeedInFlight | null,
  cellId: string
): boolean {
  if (!seed || seed.cellKey !== cellId) return false;
  input.select();
  return true;
}
